var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress",style:({ height: `${_vm.height}rem` })},[_c('div',{staticClass:"progress_bar",style:({ background: `${_vm.backgroundColor}` })},[_c('div',{staticClass:"progress_rate",style:({ width: `${_vm.progress}` + '%', height: `${_vm.height}rem`, background: `${_vm.progressColor}` })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }